import * as i0 from '@angular/core';
import * as i1 from './radio.module';
import * as i2 from './radio.component';
import * as i3 from './radio-group.component';
export const NbRadioModuleNgFactory:i0.NgModuleFactory<i1.NbRadioModule> = (null as any);
var _decl0_0:i2.NbRadioComponent = (<any>(null as any));
var _decl0_1:i3.NbRadioGroupComponent = (<any>(null as any));
var _decl0_2:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_3:i0.ElementRef<any> = (<any>(null as any));
function _View_NbRadioComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_NbRadioComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_0.name;
  currVal_0;
  const currVal_1:any = _decl0_0.value;
  currVal_1;
  const currVal_2:any = _decl0_0.checked;
  currVal_2;
  const currVal_3:any = _decl0_0.disabled;
  currVal_3;
  const pd_4:any = ((<any>_decl0_0.onChange(_any)) !== false);
  const pd_5:any = ((<any>_decl0_0.onClick(_any)) !== false);
}
function _View_NbRadioGroupComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_NbRadioGroupComponent_2_0():void {
  var _any:any = (null as any);
}
